function bindCampaignJourneyChangeListener() {
  $('body').on('change', '#campaign_journey', function () {
    if ($(this).val() == 'multiarea' || $(this).val() == 'threeway') {
      $(this).closest('.form-group').next().slideDown();
    } else {
      $(this).closest('.form-group').next().slideUp();
    }

    if ($(this).val() == 'simple') {
      $('.filter_secondary_decisions').closest('.form-group').slideUp();
    } else {
      $('.filter_secondary_decisions').closest('.form-group').slideDown();
    }
  }).closest('.form-group').next().hide();
  $('#campaign_journey').change();
}


/*** EXPORTS FROM exports-loader ***/
module.exports = bindCampaignJourneyChangeListener;